import { render, staticRenderFns } from "./checkbox-field.vue?vue&type=template&id=07e7ddee&scoped=true"
import script from "./checkbox-field.vue?vue&type=script&lang=js"
export * from "./checkbox-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e7ddee",
  null
  
)

export default component.exports